// <pos-inventory/> — 庫存管理頁（owner）
// see architecture.md#L410 (小倉)

class PosInventory extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.items = [];
    this.alerts = [];
  }

  async connectedCallback() {
    await this.loadData();
  }

  async loadData() {
    // TODO(W4): fetch from /.netlify/functions/inventory/list + /.netlify/functions/inventory/alerts
    this.render();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        :host { display: block; padding: var(--s-5); }
        h2 { font-family: var(--font-display); color: var(--brand-primary); }
        .summary {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: var(--s-4);
          margin-bottom: var(--s-6);
        }
        .stat { background: var(--bg-elevated); padding: var(--s-4); border-radius: var(--r-md); }
        .stat .v { font-size: 24px; font-weight: 600; color: var(--brand-primary); }
        .stat.alert .v { color: var(--danger); }
        table { width: 100%; border-collapse: collapse; margin-top: var(--s-4); }
        th, td { text-align: left; padding: var(--s-3); border-bottom: 1px solid var(--border); }
        th { color: var(--fg-muted); font-weight: 500; }
        .low { color: var(--warning); }
        .critical { color: var(--danger); font-weight: 600; }
        .empty { text-align: center; color: var(--fg-muted); padding: var(--s-10); background: var(--bg-elevated); border-radius: var(--r-md); }
      </style>

      <h2>📦 庫存管理</h2>

      <div class="summary">
        <div class="stat"><div>項目總數</div><div class="v">${this.items.length}</div></div>
        <div class="stat alert"><div>低庫存警告</div><div class="v">${this.alerts.length}</div></div>
        <div class="stat"><div>本月盤點次數</div><div class="v">—</div></div>
        <div class="stat"><div>小掌櫃今日提醒</div><div class="v" style="font-size:14px;"><a href="#/xiaocang" style="color:var(--brand-primary);">查看 →</a></div></div>
      </div>

      <button class="btn btn-primary">+ 新增項目</button>

      ${this.items.length === 0 ? `
        <div class="empty" style="margin-top:var(--s-5);">
          還沒設定任何庫存項目。<br/>
          <small>（W4-W5 實作 UI + 小掌櫃每日 03:00 效期掃描）</small>
        </div>
      ` : `
        <table>
          <thead>
            <tr>
              <th>項目</th>
              <th>當前</th>
              <th>警告值</th>
              <th>本週預估</th>
              <th>建議</th>
            </tr>
          </thead>
          <tbody>
            ${this.items.map((i) => `
              <tr>
                <td>${i.name}</td>
                <td>${i.current_stock} ${i.unit}</td>
                <td>${i.min_stock_alert || '-'}</td>
                <td>${i.predicted_usage_7d || '-'}</td>
                <td class="${i.alert_level || ''}">${i.recommendation || '-'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      `}
    `;
  }
}

customElements.define('pos-inventory', PosInventory);
